export const openApp = (callback?: Function) => {
  window.location.replace('receita-digital-app://');

  setTimeout(() => {
    if (callback) {
      callback();
    }
  }, 1000);
};
